import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useCheckoutProgressBarStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        columnGap: tokens.spacingHorizontalM
    },
    item: {
        height: '56px',
        width: '100%',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        ...shorthands.border(tokens.strokeWidthThin, 'solid', 'black')
    },
    text: {
        marginTop: 'auto',
        marginBottom: 'auto'
    }
});
